import React from 'react';

import {
  BrandCategorySolidIcon,
  CarAltSolidIcon,
  TireSolidIcon
} from '../../../../shared/icons/icons';
import Tabs, { Tab } from '../../../tabs/tabs';
import { TABS } from '../../fitment-constants';

import './fitment-tabs.scss';

interface FitmentTabsProps {
  hideTabs?: boolean | string[];
  onTabSelected?: (label: string) => void;
  selectedTab?: string;
}

function FitmentTabs(props: FitmentTabsProps) {
  const { hideTabs, onTabSelected, selectedTab } = props;

  function isTabHidden(tab) {
    return Array.isArray(hideTabs) && hideTabs.indexOf(tab) !== -1;
  }

  if (Boolean(hideTabs) && !Array.isArray(hideTabs)) {
    return null;
  }

  return (
    <Tabs styleName="container">
      {!isTabHidden(TABS.VEHICLE) && (
        <Tab
          isSelected={selectedTab === TABS.VEHICLE}
          onClick={() => onTabSelected?.(TABS.VEHICLE)}
        >
          <CarAltSolidIcon />

          <div styleName="label">
            Shop by&nbsp;
            <strong>{TABS.VEHICLE}</strong>
          </div>
        </Tab>
      )}
      {!isTabHidden(TABS.SIZE) && (
        <Tab
          isSelected={selectedTab === TABS.SIZE}
          onClick={() => onTabSelected?.(TABS.SIZE)}
        >
          <TireSolidIcon />

          <div styleName="label">
            Shop by&nbsp;
            <strong>{TABS.SIZE}</strong>
          </div>
        </Tab>
      )}
      {!isTabHidden(TABS.BRAND) && (
        <Tab
          isSelected={selectedTab === TABS.BRAND}
          onClick={() => onTabSelected?.(TABS.BRAND)}
        >
          <BrandCategorySolidIcon />

          <div styleName="label">
            Shop by&nbsp;
            <strong>{TABS.BRAND}</strong>
          </div>
        </Tab>
      )}
    </Tabs>
  );
}

export default FitmentTabs;
